/* lc-cuore.js - sostituisce gli script dell'app PageFly sulla landing Bouquet Cuore. */
(function(){
'use strict';
function qa(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }
function money(c){ var v=(c/100).toFixed(2).replace('.',','); return '\u20ac'+v; }
var PFT='[data-pf-type=';

/* ---------- 1. fisarmonica ---------- */
function accordion(){
 qa(PFT+'"Accordion3.Content.Wrapper"]').forEach(function(d){
  if(d.__lc) return; d.__lc=1;
  var body=d.querySelector(PFT+'"Accordion3.Content"]');
  var hdr=d.querySelector(PFT+'"Accordion3.Header"]');
  if(!body) return;
  var grid = getComputedStyle(body).display.indexOf('grid')>-1;
  function paint(){
   var open=d.hasAttribute('open');
   if(hdr) hdr.setAttribute('data-active', open?'true':'false');
   if(grid){ body.style.setProperty('grid-template-rows', open?'1fr':'0fr'); }
   else {
    body.style.setProperty('overflow','hidden');
    var inner=body.firstElementChild;
    var h=inner?inner.scrollHeight:body.scrollHeight;
    body.style.setProperty('height', open? h+'px' : '0px');
    if(open) setTimeout(function(){ if(d.hasAttribute('open')) body.style.setProperty('height','auto'); },300);
   }
  }
  d.addEventListener('toggle', paint);
  paint();
 });
}

/* ---------- 2. schede ---------- */
function tabs(){
 qa(PFT+'"Tabs3"]').forEach(function(t){
  if(t.__lc) return; t.__lc=1;
  var hs=qa(PFT+'"TabHeader3"]', t).filter(function(h){ return !/pf-tab-(prev|next)-btn/.test(h.className); });
  var cs=qa(PFT+'"TabsContent3"]', t);
  if(!hs.length || !cs.length) return;
  function show(i){
   hs.forEach(function(h,k){ h.setAttribute('data-pf-tab-active', k===i?'true':'false'); });
   cs.forEach(function(c,k){ if(k===i){ c.style.removeProperty('display'); } else { c.style.setProperty('display','none','important'); } });
  }
  hs.forEach(function(h,i){ h.addEventListener('click', function(e){ e.preventDefault(); show(i); }); });
  var start=0; hs.forEach(function(h,k){ if(h.getAttribute('data-pf-tab-active')==='true') start=k; });
  show(start);
 });
}

/* ---------- 3. caroselli ---------- */
function sliders(){
 qa('.pf-slider').forEach(function(s){
  if(s.__lc) return; s.__lc=1;
  var box=s.closest(PFT+'"Slideshow"]') || s.parentElement;
  var prev=box.querySelector('.pf-slider-prev'), next=box.querySelector('.pf-slider-next');
  function step(){ var f=s.firstElementChild; return f ? Math.max(120, f.getBoundingClientRect().width + 12) : s.clientWidth*0.8; }
  function paint(){
   var max=s.scrollWidth - s.clientWidth - 2;
   if(prev) prev.classList.toggle('hide', s.scrollLeft<=2);
   if(next) next.classList.toggle('hide', s.scrollLeft>=max);
  }
  if(prev) prev.addEventListener('click', function(e){ e.preventDefault(); s.scrollBy({left:-step(), behavior:'smooth'}); });
  if(next) next.addEventListener('click', function(e){ e.preventDefault(); s.scrollBy({left: step(), behavior:'smooth'}); });
  s.addEventListener('scroll', paint, {passive:true});
  window.addEventListener('resize', paint);
  paint();
 });
}

/* ---------- 4. prodotto: varianti, prezzo, foto, quantita, carrello ---------- */
function prodData(pid){ var P=window.__pageflyProducts||{}; return P[pid]||null; }
function boxOf(el){ return el.closest(PFT+'"ProductBox"]') || el.closest(PFT+'"ProductMedia2"]') || document; }
var CUR={};
function setVariant(pid, vid, scope){
 CUR[pid]=vid;
 var d=prodData(pid); if(!d||!d.variants) return;
 var v=null; d.variants.forEach(function(x){ if(String(x.id)===String(vid)) v=x; });
 if(!v) return;
 var root = scope && scope!==document ? scope : document;
 qa(PFT+'"ProductPrice2Item"]', root).forEach(function(p){ p.textContent=money(v.price); });
 if(v.featured_image && v.featured_image.src){
  qa(PFT+'"MediaMain2"] img, '+PFT+'"ProductMedia2"] img', root).slice(0,1).forEach(function(im){ im.src=v.featured_image.src.split('?')[0]+'?width=1000'; im.removeAttribute('srcset'); });
 }
 qa('input[type=radio]', root).forEach(function(i){ if((i.id||'').indexOf('-'+vid)>-1) i.checked=true; });
}
function swatches(){
 qa(PFT+'"ProductVariantSwatches"]').forEach(function(sw){
  if(sw.__lc) return; sw.__lc=1;
  var pid=sw.getAttribute('data-product-id');
  sw.addEventListener('click', function(e){
   var lb=e.target.closest('label[for]'); if(!lb) return;
   var f=lb.getAttribute('for')||''; var vid=f.split('-').pop();
   if(!/^[0-9]{6,}$/.test(vid)) return;
   setVariant(pid, vid, boxOf(sw));
  });
  var box=boxOf(sw);
  var def=(box&&box.getAttribute)?box.getAttribute('data-default-variant'):null;
  if(def) CUR[pid]=def;
 });
}
function quantity(){
 qa(PFT+'"ProductQuantity"]').forEach(function(q){
  if(q.__lc) return; q.__lc=1;
  var f=q.querySelector('input');
  q.addEventListener('click', function(e){
   var b=e.target.closest(PFT+'"QuantityButton"]'); if(!b||!f) return;
   e.preventDefault();
   var n=parseInt(f.value||'1',10); if(isNaN(n)) n=1;
   var minus=/minus|dec|-/i.test(b.getAttribute('data-type')||b.getAttribute('aria-label')||b.textContent||'');
   n = minus ? Math.max(1,n-1) : n+1;
   f.value=n; f.dispatchEvent(new Event('change',{bubbles:true}));
  });
 });
}
function atc(){
 qa(PFT+'"ProductATC2"]').forEach(function(b){
  if(b.__lc) return; b.__lc=1;
  b.addEventListener('click', function(e){
   e.preventDefault(); e.stopPropagation();
   var pid=b.getAttribute('data-product-id');
   var box=boxOf(b);
   var vid=CUR[pid] || (box&&box.getAttribute?box.getAttribute('data-default-variant'):null);
   if(!vid){ var d=prodData(pid); if(d&&d.variants&&d.variants[0]) vid=d.variants[0].id; }
   if(!vid) return;
   var qf=box&&box.querySelector?box.querySelector(PFT+'"QuantityField"] input, '+PFT+'"ProductQuantity"] input'):null;
   var qty=qf?parseInt(qf.value||'1',10):1; if(isNaN(qty)||qty<1) qty=1;
   var lab=b.innerHTML, busy=b.getAttribute('data-adding'), done=b.getAttribute('data-added');
   if(busy) b.textContent=busy;
   b.disabled=true;
   fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:qty}]})})
    .then(function(r){ if(!r.ok) throw 0; return r.json(); })
    .then(function(){
      b.disabled=false; if(done) b.textContent=done; setTimeout(function(){ b.innerHTML=lab; },1400);
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      var t=document.querySelector('a.action__cart, a.header-actions__action.action__cart, [data-sv-open], header a[href="/cart"]');
      if(t){ t.click(); } else { document.dispatchEvent(new CustomEvent('sv:cart:open',{bubbles:true})); setTimeout(function(){ if(!document.querySelector('aside.sv-cart.on')) window.location.href='/cart'; }, 900); }
    })
    .catch(function(){ b.disabled=false; b.innerHTML=lab; window.location.href='/cart'; });
  }, true);
 });
}
function media(){
 qa(PFT+'"MediaListItem2"]').forEach(function(it){
  if(it.__lc) return; it.__lc=1;
  it.addEventListener('click', function(){
   var im=it.querySelector('img'); if(!im) return;
   var root=it.closest(PFT+'"ProductMedia2"]')||document;
   var main=root.querySelector(PFT+'"MediaMain2"] img'); if(!main) return;
   main.src=(im.currentSrc||im.src).split('?')[0]+'?width=1000'; main.removeAttribute('srcset');
   qa(PFT+'"MediaListItem2"]', root).forEach(function(x){ x.setAttribute('data-active', x===it?'true':'false'); });
  });
 });
}
function boot(){ try{accordion();}catch(e){} try{tabs();}catch(e){} try{sliders();}catch(e){} try{swatches();}catch(e){} try{quantity();}catch(e){} try{atc();}catch(e){} try{media();}catch(e){} }
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
setTimeout(boot, 800); setTimeout(boot, 2200);
window.lcCuoreBoot = boot;
})();
